import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import Header from "../../layouts/Header.js";
import {
  addTask,
  deleteTask,
  FetchToDoList,
  FetchToDoListByProject,
  ChangeStatus,
  UpdateTaskAssigee,
  UpdateTaskPriority,
  UpdateTaskIndex,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { API_URL } from "../../redux/constants/type.js";
import { Tooltip, Empty, Dropdown, DatePicker, Select } from "antd";
import {
  CheckCircleOutlined,
  CheckCircleFilled,
  SyncOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import AppDatePicker from "../../components/Common/AppDatePicker";
import AddTaskModal from "../../components/Dailogs/AddTaskModal";
import TaskDelete from "../../components/Dailogs/TaskDelete";
import moment from "moment";
import deleteIcon from "../../assets/icons/Bin.svg";
import AddButton from "../../assets/icons/Card Add button.svg";
import calendar from "../../assets/icons/calendar.svg";
import plusCircle from "../../assets/icons/plusCircle.svg";
import dayjs from "dayjs";
import bin from "../../assets/icons/Bin.svg";
import checked from "../../assets/icons/Checked.svg";
import roundFileSize from "../../utils/Documents/roundFileSize";
import "../../assets/styles/local/ToDoList.css";
import AssigneeModal from "./ASC_AssigneeModal.js";
import Pagination from "../../components/Pagination/Pagination";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const ToDoList = (props) => {
  const dispatch = useDispatch();
  const [Ankit] = useAutoAnimate();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const hidden_Input_File = useRef(null);
  const completeStatuID = "08dab011-a6cf-4069-887e-83e5f3473103";
  const todoStatuID = "08dab011-a6cf-4069-887e-83e5f3473101";

  const companyId = window.localStorage.getItem("companyid");
  const userid = window.localStorage.getItem("userid");
  const userName = window.localStorage.getItem("firstname");
  const primaryColor = window.localStorage.getItem("primarycolor");
  const packageID = window.localStorage.getItem("packageId");

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("To Do List").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const fetchTasksResponse = useSelector(
    (state) => state.user.fetchTasksResponse,
  );

  const fetchToDoListApiRes = useSelector(
    (state) => state.user.fetchToDoListApiRes,
  );

  const fetchTodoListByProjectRes = useSelector(
    (state) => state.user.fetchTodoListByProjectRes,
  );

  const addTaskResponse = useSelector((state) => state.user.addTaskResponse);

  const deleteTaskResponse = useSelector(
    (state) => state.user.deleteTaskResponse,
  );

  const updateTaskAssigneeApiRes = useSelector(
    (state) => state.user.updateTaskAssigneeApiRes,
  );

  const updateTaskIndexApiRes = useSelector(
    (state) => state.user.updateTaskIndexApiRes,
  );

  const changeStatus = useSelector((state) => state.user.changeStatus);

  const [searchText, setSearchText] = useState("");
  const [showLoader, setShowLoader] = useState(true);
  const [modalFunction, setModalFunction] = useState("add");
  const [allTasks, setAllTasks] = useState([]);
  const [fetchAssignees, setFetchAssignees] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [statusName, setStatusName] = useState("");
  const [statusID, setStatusID] = useState("");
  const [taskid, setTaskid] = useState("");

  const [deleteModalShow, setDeleteModalShow] = useState(false);

  ///////////////// props for Task Modal.
  const [comments, setComments] = useState([]);
  const [maxComments, setMaxComments] = useState([]);
  const [show, setShow] = useState([]);
  const [val, setVal] = useState("");
  ////////////////

  // for pagination start
  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  // for pagination end

  const [newTask, setNewTask] = useState({
    firstName: "",
    endDate: dayjs(new Date()),
    priorityid: "08da8a3e-d43a-40b9-845d-ba8c2e749694", // Normal priority by default
    checked: false,
  });

  const [priorityPopupShow, setPriorityPopupShow] = useState(false);

  const priorityOptions = [
    {
      value: "08da8a3e-d43a-40b9-845d-ba8c2e749693",
      // label: "Low",
      label: t("Low"),
      color: "#333333",
    },
    {
      value: "08da8a3e-d43a-40b9-845d-ba8c2e749694",
      // label: "Normal",
      label: t("Normal"),
      color: "#477400",
    },
    {
      value: "08da8a3e-d43a-40b9-845d-ba8c2e749692",
      // label: "High",
      label: t("High"),
      color: "#FFA43B",
    },
    {
      value: "08da8a3e-d43a-40b9-845d-ba8c2e749691",
      // label: "Extreme",
      label: t("Extreme"),
      color: "#D01200",
    },
  ];

  const handleNewTaskChange = (field, value) => {
    setNewTask((prev) => ({ ...prev, [field]: value }));
  };

  const addNewTask = () => {
    if (newTask.firstName.trim()) {
      const assigneeMain = isNewAssigneeData.map((item) => ({
        assigneeid: item.id,
        type: "user",
      }));

      dispatch(
        addTask(
          userid,
          companyId,
          // null, // project id
          props?.projectid ?? null, // project id
          newTask.firstName, // title
          "", // description
          // undefined, // client contact id
          props?.clientid ?? undefined, // client contact id
          "08dab011-a6cf-4069-887e-83e5f3473101", // status id (To Do)
          newTask.priorityid, // priority id
          newTask.endDate.format("YYYY-MM-DD HH:mm:ss"), // datetime
          "notify", // nminutes
          "Don't", // notiTime
          "Task", // typeOfTask
          [], // dependencyMain
          "0", // estimatedTime
          [], // checklist
          assigneeMain,
          props?.deliveryAddress ?? "", // workAddress
          [], // equipmentPayload
          // "00000000-0000-0000-0000-000000000000", // sectionId
          "6aac7d7b-9cd0-4553-807d-ca1c7673bfa6", // sectionId
          dayjs().format("YYYY-MM-DD"), // startDate - today's date
          newTask.endDate.format("YYYY-MM-DD HH:mm:ss"), // datetime
        ),
      );

      // Reset new task form
      setNewTask({
        firstName: "",
        endDate: dayjs(new Date()),
        priorityid: "08da8a3e-d43a-40b9-845d-ba8c2e749694",
        checked: false,
      });
      setIsNewAssigneeData([]);
    }
  };

  const buildAssigneePayload = () => {
    if (isNewAssignee || !taskid) return;

    // dispatch(
    //   UpdateTaskAssigee({
    //     taskid: taskid,
    //     taskassignee: assigneeData.map((user) => ({
    //       assigneeid: user.id,
    //     })),
    //   })
    // );

    dispatch(
      UpdateTaskAssigee({
        taskid: taskid,
        taskassignee: Array.from(
          new Set(assigneeData.map((user) => user.id)),
        ).map((id) => ({
          assigneeid: id,
        })),
      }),
    );
  };

  // for Date Label start.
  const formatDateLabel = (date) => {
    if (!date) return "";

    const dateMoment = dayjs(date);
    const today = dayjs().startOf("day");
    const yesterday = dayjs().subtract(1, "days").startOf("day");
    const tomorrow = dayjs().add(1, "days").startOf("day");

    // Check if the date is today, yesterday, or tomorrow, and return the appropriate label
    if (dateMoment.isSame(today, "day")) {
      return "Today";
    } else if (dateMoment.isSame(yesterday, "day")) {
      return "Yesterday";
    } else if (dateMoment.isSame(tomorrow, "day")) {
      return "Tomorrow";
    } else {
      return dateMoment.format("DD MMM"); // Default format for other dates
    }
  };
  // for Date Label end.

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addNewTask();
    }
  };

  useEffect(() => {
    if (location.pathname === "/todolist") {
      dispatch(
        FetchToDoList({
          pagerequire: perPage,
          pagenumber: currentPage + 1,
          querystring: searchText,
        }),
      );
    } else {
      dispatch(
        FetchToDoListByProject({
          projectid: props?.projectid,
          pagerequire: perPage,
          pagenumber: currentPage + 1,
          querystring: searchText,
        }),
      );
    }
  }, [
    location.pathname,
    props?.projectid,
    addTaskResponse,
    deleteTaskResponse,
    updateTaskAssigneeApiRes,
    changeStatus,
    searchText,
    currentPage,
    perPage,
  ]);

  useEffect(() => {
    if (location.pathname === "/todolist") {
      if (fetchToDoListApiRes?.status === true) {
        setAllTasks(fetchToDoListApiRes?.data);
        setTotalPages(Math.ceil(fetchToDoListApiRes?.totalCount / perPage));
        setShowLoader(false);
      }
    }
  }, [location.pathname, fetchToDoListApiRes, perPage]);

  useEffect(() => {
    if (location.pathname !== "/todolist") {
      if (fetchTodoListByProjectRes?.status === true) {
        setAllTasks(fetchTodoListByProjectRes?.data);
        setTotalPages(
          Math.ceil(fetchTodoListByProjectRes?.totalCount / perPage),
        );
        setShowLoader(false);
      }
    }
  }, [location.pathname, fetchTodoListByProjectRes, perPage]);

  const handleDelete = (e) => {
    dispatch(deleteTask(taskid));
    setDeleteModalShow(false);
  };

  const PriorityOld = (priorityid) => {
    if (priorityid === "08da8a3e-d43a-40b9-845d-ba8c2e749693") return "Low";
    if (priorityid === "08da8a3e-d43a-40b9-845d-ba8c2e749692") return "High";
    if (priorityid === "08da8a3e-d43a-40b9-845d-ba8c2e749694") return "Normal";
    if (priorityid === "08da8a3e-d43a-40b9-845d-ba8c2e749691") return "Extreme";
    return "_";
  };

  const Priority = (priorityid) => {
    if (priorityid === "08da8a3e-d43a-40b9-845d-ba8c2e749693") {
      return <span style={{ color: "#333333" }}>Low</span>;
    }
    if (priorityid === "08da8a3e-d43a-40b9-845d-ba8c2e749692") {
      return <span style={{ color: "#FFA43B" }}>High</span>;
    }
    if (priorityid === "08da8a3e-d43a-40b9-845d-ba8c2e749694") {
      return <span style={{ color: "#477400" }}>Normal</span>;
    }
    if (priorityid === "08da8a3e-d43a-40b9-845d-ba8c2e749691") {
      return <span style={{ color: "#D01200" }}>Extreme</span>;
    }
    return "_";
  };

  // stock assignees Data
  const [assigneeModelOpen, setAssigneeModelOpen] = useState(false);

  const [isNewAssignee, setIsNewAssignee] = useState(false);
  const [isNewAssigneeData, setIsNewAssigneeData] = useState([]);
  const [existingTaskAssignees, setExistingTaskAssignees] = useState([]);
  const assigneeData = isNewAssignee
    ? isNewAssigneeData
    : existingTaskAssignees;
  const setAssigneeData = isNewAssignee
    ? setIsNewAssigneeData
    : setExistingTaskAssignees;

  console.log("asc56 authData", assigneeData);

  // callback fun() for data passing to child and taking data 👇.
  const addUsersData = (asc, string) => {
    if (string === "single") {
      console.log("asc66", asc, string);
      setAssigneeData([...assigneeData, asc]);
    }
    if (asc.length > 1) {
      // here ... will add and open asc array.
      setAssigneeData([...assigneeData, ...asc]);
    }
  };

  const removeUsersData = (asc, string) => {
    if (string === "single") {
      let workers = assigneeData.filter((x) => x.id !== asc.id);
      setAssigneeData(workers);
    }
    if (asc.length > 1) {
      let workers = assigneeData.filter(
        (x) => !asc.some((user) => user.id === x.id),
      );
      setAssigneeData(workers);
    }
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(allTasks);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setAllTasks(items);

    // Dynamic payload based on new order
    const payload = items.map((task, index) => ({
      taskid: task.taskid,
      indexPosition: index,
    }));

    // dispatch(
    //   UpdateTaskIndex({
    //     taskIndex: payload,
    //   })
    // );

    const maxIndex = Math.max(...items.map((x) => x.indexPosition));

    dispatch(
      UpdateTaskIndex({
        taskIndex: items.map((task, index) => ({
          taskid: task.taskid,
          indexPosition: maxIndex - index,
        })),
      }),
    );
  };

  // Global keydown listener for Enter key
  useEffect(() => {
    const handleGlobalKeyDown = (e) => {
      if (e.key === "Enter" && newTask.firstName.trim()) {
        // Check if we're not in a modal or dropdown
        if (!assigneeModelOpen && !priorityPopupShow) {
          e.preventDefault();
          addNewTask();
        }
      }
    };

    document.addEventListener("keydown", handleGlobalKeyDown);
    return () => {
      document.removeEventListener("keydown", handleGlobalKeyDown);
    };
  }, [newTask, isNewAssigneeData, assigneeModelOpen, priorityPopupShow]);

  const todoInputRef = useRef(null);

  console.log("asc444", taskid);

  return (
    <div>
      {location.pathname === "/todolist" && (
        <Header
          setQuery={setSearchText}
          leftComponent={
            <div className="headerContainer">
              <div
                className="dashboardTitle pointer"
                onClick={() => history.push("/todolist")}
              >
                {/* To Do List */}
                {t("To Do List")}
              </div>
            </div>
          }
        />
      )}

      {deleteModalShow && (
        <TaskDelete
          animation={true}
          handleDelete={handleDelete}
          show={deleteModalShow}
          onHide={() => setDeleteModalShow(false)}
        />
      )}

      {showModal && (
        <AddTaskModal
          modelTypeId={statusID}
          showModal={showModal}
          setShowModal={setShowModal}
          taskid={taskid}
          setTaskid={setTaskid}
          modalFunction={modalFunction}
          setModalFunction={setModalFunction}
          from={"ToDoList_Screen"}
          setComments={setComments}
          setMaxComments={setMaxComments}
          show={show}
          setShow={setShow}
          setVal={setVal}
        />
      )}

      <div
        className="ps-4 pt-3"
        style={{
          background: "#FAFAFA",
        }}
      >
        <span
          className="ps-4 d-inline-flex gap-2 align-items-center pointer"
          onClick={() => {
            // setShowModal(true);
            setModalFunction("add");
            setStatusName("To Do");
            setStatusID("08dab011-a6cf-4069-887e-83e5f3473101");

            setTimeout(() => {
              todoInputRef.current?.focus();
            }, 300);
          }}
        >
          <img src={AddButton} alt="" width={20} />
          <p className="mb-0 todoHeader">
            {/* Add a To Do */}
            {t("Add a To Do")}
          </p>
        </span>
      </div>

      <div
        className="p-3 tableWrapper"
        style={{
          position: "relative",
          // overflow: "auto",
          // height: "auto",
          // maxHeight: "auto",
        }}
      >
        <table className="table table-bordered">
          <thead>
            <tr
              className="tableHeading-NewInvoice z-1 todoHeader"
              style={{ backgroundColor: "#FAFAFA" }}
            >
              <th
                style={{
                  width: "2%",
                  display: "none",
                }}
              ></th>
              <th style={{ width: "2%" }}></th>
              <th style={{ width: "2%" }}></th>
              <th
                style={{
                  width: "40%",
                  textAlign: "left",
                }}
              >
                {/* My To Dos */}
                {t("My To Dos")}
              </th>
              <th
                style={{
                  width: "10%",
                  textAlign: "left",
                }}
              >
                {/* Deadline */}
                {t("Deadline")}
              </th>
              <th
                style={{
                  width: "25%",
                  textAlign: "left",
                }}
              >
                {/* Assignee */}
                {t("Assignee")}
              </th>
              <th
                style={{
                  width: "5%",
                  textAlign: "left",
                }}
              >
                {/* Priority */}
                {t("Priority")}
              </th>
              <th></th>
            </tr>
          </thead>

          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="tasks" type="TASK">
              {(provided) => (
                <tbody
                  className="tabLine"
                  style={{ borderTop: "none" }}
                  // ref={Ankit}
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  {/* First row - always empty for new task input */}
                  <tr
                    className=""
                    style={{ backgroundColor: "#ffffff" }}
                    onKeyDown={handleKeyDown}
                    tabIndex={0}
                  >
                    <td className="align-middle">||</td>

                    <td className="align-middle d-none">
                      <span style={{ opacity: 0.3 }}>✨</span>
                    </td>

                    <td
                      className="align-middle"
                      onClick={() => {
                        if (newTask.firstName.trim()) {
                          // Mark the new task as complete when added
                          const taskToAdd = {
                            ...newTask,
                            taskid: Date.now().toString(),
                            statusname: "Complete",
                            statusid: completeStatuID,
                            checked: true,
                          };
                          setAllTasks((prev) => [taskToAdd, ...prev]);
                          setNewTask({
                            firstName: "",
                            endDate: dayjs(new Date()),
                            priorityid: "08da8a3e-d43a-40b9-845d-ba8c2e749694",
                            checked: false,
                          });
                        }
                      }}
                    >
                      <Tooltip
                        // title={"Mark as completed"}
                        color={"white"}
                        overlayInnerStyle={{
                          color: "black",
                          fontWeight: "500",
                        }}
                      >
                        <CheckCircleOutlined
                          style={{ opacity: 0.3, fontSize: "16px" }}
                        />
                      </Tooltip>
                    </td>

                    <td
                      className="todolistTitle"
                      onClick={() => {
                        setTaskid("");
                      }}
                    >
                      <input
                        type="text"
                        // placeholder="Add a ToDo..."
                        placeholder={t("Add a ToDo...")}
                        className="checklistInput my-2"
                        style={{ width: "95%" }}
                        value={newTask.firstName}
                        onChange={(e) =>
                          handleNewTaskChange("firstName", e.target.value)
                        }
                        // onKeyDown={handleKeyDown}
                        autoFocus
                        ref={todoInputRef}
                      />

                      <span className="ms-auto mx-3">
                        {newTask.firstName.trim() && (
                          <CheckOutlined
                            style={{ fontSize: "16px" }}
                            onClick={() => {
                              addNewTask();
                            }}
                          />
                        )}
                      </span>
                    </td>

                    <td className="todoHeader">
                      <DatePicker
                        id="asc_Date"
                        className={
                          formatDateLabel(newTask.endDate) === "Today" ||
                          formatDateLabel(newTask.endDate) === "Yesterday" ||
                          formatDateLabel(newTask.endDate) === "Tomorrow"
                            ? "pointer customDateInput dateInCheckListInRed ps-0"
                            : "pointer customDateInput dateInCheckList ps-0"
                        }
                        placeholder="Select End Date"
                        value={newTask.endDate}
                        format={formatDateLabel}
                        onChange={(e) => handleNewTaskChange("endDate", e)}
                        variant="borderless"
                        allowClear={false}
                        suffixIcon={null}
                        size="large"
                      />
                    </td>

                    <td className="d-flex ps-4 text-start position-relative">
                      <span>
                        {isNewAssigneeData?.length > 0 && (
                          <div className="d-flex ps-3">
                            {isNewAssigneeData
                              ?.slice(0, 3)
                              .map((newAssignee, idx2) => {
                                return (
                                  <div key={newAssignee?.id}>
                                    {newAssignee.imageurl ? (
                                      <img
                                        className="abbre-img2"
                                        src={newAssignee?.imageurl}
                                        alt=""
                                      />
                                    ) : (
                                      <div className="abbre-pop2">
                                        {newAssignee?.lastName
                                          ? newAssignee?.firstName[0]?.toUpperCase() +
                                            "" +
                                            newAssignee?.lastName[0]?.toUpperCase()
                                          : newAssignee?.firstName
                                              ?.slice(0, 2)
                                              .toUpperCase()}
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            {isNewAssigneeData?.length > 3 && (
                              <div className="px-1 lengthInCircle2">
                                +{isNewAssigneeData?.length - 3}
                              </div>
                            )}
                          </div>
                        )}
                      </span>
                      <Dropdown
                        trigger="click"
                        open={assigneeModelOpen}
                        // onOpenChange={setAssigneeModelOpen}
                        dropdownRender={() => (
                          <AssigneeModal
                            sendingData={assigneeData} // only sending Data.
                            addUsersData={addUsersData}
                            removeUsersData={removeUsersData}
                            // closeAssigneeModal={setAssigneeModelOpen}
                            closeAssigneeModal={() => {
                              buildAssigneePayload();
                              setAssigneeModelOpen(false);
                            }}
                            // headerMaxAmount={headerMaxAmount}
                            // setHeaderMaxAmount={setHeaderMaxAmount}
                            showWorkersTab={true}
                            showTeamsTab={false}
                            showSelectedDisabled={true}
                            // fetchAssignees={fetchAssignees}
                            fetchAssignees={isNewAssignee ? [] : fetchAssignees}
                            style={{
                              position: "unset",
                              width: "500px",
                              maxWidth: "450px",
                            }}
                          />
                        )}
                      >
                        <img
                          src={plusCircle}
                          alt=""
                          width={25}
                          className="pointer"
                          onClick={() => {
                            setIsNewAssignee(true);
                            setTaskid("");
                            setAssigneeModelOpen(!assigneeModelOpen);
                          }}
                        />
                      </Dropdown>
                    </td>

                    <td className="todoHeader">
                      <Select
                        className="priority-select"
                        popupClassName="priority-popup"
                        value={newTask.priorityid}
                        onChange={(value) =>
                          handleNewTaskChange("priorityid", value)
                        }
                        variant="borderless"
                        size="large"
                        open={priorityPopupShow}
                        onDropdownVisibleChange={setPriorityPopupShow}
                        style={{ width: "115px" }}
                      >
                        {priorityOptions.map((option) => (
                          <Select.Option
                            key={option.value}
                            value={option.value}
                          >
                            <span style={{ color: option.color }}>
                              {option.label}
                            </span>
                          </Select.Option>
                        ))}
                      </Select>
                    </td>

                    <td></td>

                    <td className="todolistTitle d-none">
                      {newTask.firstName.trim() && (
                        <CheckOutlined
                          style={{ fontSize: "16px" }}
                          onClick={() => {
                            addNewTask();
                          }}
                        />
                      )}
                    </td>
                  </tr>

                  {/* Existing tasks */}
                  {allTasks
                    .sort(
                      (a, b) =>
                        (a.statusid === completeStatuID) -
                        (b.statusid === completeStatuID),
                    )
                    .map((item, index) => {
                      return (
                        <Draggable
                          key={item.taskid}
                          draggableId={item.taskid}
                          index={index}
                          isDragDisabled={item.statusid === completeStatuID}
                        >
                          {(provided) => (
                            <tr
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              // className="TableRowClass"
                              className={
                                item.statusid === completeStatuID
                                  ? "TableRowClass pointerEvent"
                                  : "TableRowClass"
                              }
                              style={{
                                backgroundColor: "#ffffff",
                                borderTop: "1px solid #dee2e6",
                                borderBottom: "1px solid #dee2e6",
                                ...provided.draggableProps.style,
                              }}
                              key={item.taskid || index}
                              onClick={() => {
                                setTaskid(item.taskid);
                                setStatusID(item.statusid);
                              }}
                            >
                              <td
                                className="align-middle pointer"
                                {...provided.dragHandleProps}
                              >
                                ||
                              </td>
                              <td className="align-middle pointer px-2 d-none">
                                <Tooltip
                                  // title={"To Do created by Spire GPT"}
                                  title={t("To Do created by Spire GPT")}
                                  color={"white"}
                                  overlayInnerStyle={{
                                    color: "black",
                                    fontWeight: "500",
                                  }}
                                >
                                  <span>✨</span>
                                </Tooltip>
                              </td>
                              <td
                                className="align-middle pointer"
                                style={{ pointerEvents: "auto", opacity: 1 }}
                                onClick={() => {
                                  if (item.statusid === todoStatuID) {
                                    dispatch(
                                      ChangeStatus(
                                        item.taskid,
                                        completeStatuID,
                                      ),
                                    );

                                    const maxIndex = Math.max(
                                      ...allTasks.map(
                                        (task) => task.indexPosition || 0,
                                      ),
                                    );

                                    dispatch(
                                      UpdateTaskIndex({
                                        taskIndex: [
                                          {
                                            taskid: item.taskid,
                                            indexPosition: maxIndex + 1,
                                          },
                                        ],
                                      }),
                                    );
                                  }

                                  if (item.statusid === completeStatuID) {
                                    dispatch(
                                      ChangeStatus(item.taskid, todoStatuID),
                                    );

                                    const minIndex = Math.min(
                                      ...allTasks.map(
                                        (task) => task.indexPosition || 0,
                                      ),
                                    );

                                    dispatch(
                                      UpdateTaskIndex({
                                        taskIndex: [
                                          {
                                            taskid: item.taskid,
                                            indexPosition: minIndex - 1,
                                          },
                                        ],
                                      }),
                                    );
                                  }
                                }}
                              >
                                <Tooltip
                                  // title={"Mark as completed"}
                                  title={
                                    item.statusid === completeStatuID
                                      ? "Mark as Todo"
                                      : t("Mark as completed")
                                  }
                                  color={"white"}
                                  overlayInnerStyle={{
                                    color: "black",
                                    fontWeight: "500",
                                  }}
                                >
                                  {item.statusid === completeStatuID ? (
                                    <CheckCircleFilled
                                      className={"h6 m-0"}
                                      style={{ color: "#B0DD69" }}
                                    />
                                  ) : (
                                    <CheckCircleOutlined className={"h6 m-0"} />
                                  )}
                                </Tooltip>
                              </td>
                              <td className="todolistTitle">
                                <div
                                  className="my-2"
                                  style={{
                                    textDecoration:
                                      (item.checked ||
                                        item.statusname === "Complet-e") &&
                                      "line-through",
                                  }}
                                >
                                  {item.firstName || item.taskname}
                                </div>
                              </td>
                              <td className="todoHeader ps-4">
                                <div
                                  className={
                                    formatDateLabel(
                                      item.endDate || item.creationDate,
                                    ) === "Today" ||
                                    formatDateLabel(
                                      item.endDate || item.creationDate,
                                    ) === "Yesterday" ||
                                    formatDateLabel(
                                      item.endDate || item.creationDate,
                                    ) === "Tomorrow"
                                      ? "pointer dateInCheckListInRed d-none"
                                      : "pointer dateInCheckList d-none"
                                  }
                                >
                                  {formatDateLabel(
                                    item.endDate || item.creationDate,
                                  )}
                                </div>
                                <DatePicker
                                  id="asc_Date"
                                  className={
                                    formatDateLabel(item.endDate) === "Today" ||
                                    formatDateLabel(item.endDate) ===
                                      "Yesterday" ||
                                    formatDateLabel(item.endDate) === "Tomorrow"
                                      ? "pointer customDateInput dateInCheckListInRed ps-0"
                                      : "pointer customDateInput dateInCheckList ps-0"
                                  }
                                  placeholder="Select End Date"
                                  value={
                                    item.endDate ? dayjs(item.endDate) : null
                                  }
                                  format={formatDateLabel}
                                  onChange={(e) => {
                                    // handleNewTaskChange("endDate", e);
                                    const updatedTasks = allTasks.map((task) =>
                                      task.taskid === item.taskid
                                        ? { ...task, endDate: e }
                                        : task,
                                    );
                                    setAllTasks(updatedTasks);
                                    dispatch(
                                      UpdateTaskPriority({
                                        taskid: item.taskid,
                                        priorityid: item.priorityid,
                                        // endDate: e,
                                        endDate: dayjs(e).format("YYYY-MM-DD"),
                                      }),
                                    );
                                  }}
                                  variant="borderless"
                                  allowClear={false}
                                  suffixIcon={null}
                                  size="large"
                                />
                              </td>
                              <td className="ps-4 py-1 text-start d-flex gap-1">
                                {item?.assigneedetail?.length > 0 && (
                                  <div className="d-flex ps-3">
                                    {item?.assigneedetail
                                      ?.slice(0, 3)
                                      .map((assignee, idx) => {
                                        return (
                                          <div key={idx}>
                                            {assignee.assigneeimage ? (
                                              <img
                                                className="abbre-img2"
                                                src={assignee?.assigneeimage}
                                                alt=""
                                              />
                                            ) : (
                                              <div className="abbre-pop2">
                                                {assignee?.lastname
                                                  ? assignee?.assigneename[0]?.toUpperCase() +
                                                    "" +
                                                    assignee?.lastname[0]?.toUpperCase()
                                                  : assignee?.assigneename
                                                      ?.slice(0, 2)
                                                      .toUpperCase()}
                                              </div>
                                            )}
                                          </div>
                                        );
                                      })}
                                    {item?.assigneedetail?.length > 3 && (
                                      <div className="px-1 lengthInCircle2">
                                        +{item?.assigneedetail?.length - 3}
                                      </div>
                                    )}
                                  </div>
                                )}

                                <img
                                  src={plusCircle}
                                  alt=""
                                  width={25}
                                  className="pointer"
                                  onClick={(e) => {
                                    setIsNewAssignee(false);
                                    setAssigneeModelOpen(!assigneeModelOpen);
                                    setExistingTaskAssignees(
                                      item.assigneedetail.map((a) => ({
                                        id: a.assigneeid,
                                        firstName: a.assigneename,
                                        type: "single",
                                      })),
                                    );

                                    setFetchAssignees(
                                      item.assigneedetail.map((a) => ({
                                        id: a.assigneeid,
                                        firstName: a.assigneename,
                                        type: "single",
                                      })),
                                    );
                                  }}
                                />
                              </td>
                              <td className="todoHeader">
                                <Select
                                  className="priority-select"
                                  popupClassName="priority-popup"
                                  value={item.priorityid}
                                  onChange={(value) => {
                                    // Update priority in local state
                                    const updatedTasks = allTasks.map((task) =>
                                      task.taskid === item.taskid
                                        ? { ...task, priorityid: value }
                                        : task,
                                    );
                                    setAllTasks(updatedTasks);
                                    dispatch(
                                      UpdateTaskPriority({
                                        taskid: item.taskid,
                                        priorityid: value,
                                        endDate: item.endDate,
                                      }),
                                    );
                                  }}
                                  variant="borderless"
                                  size="small"
                                  style={{ width: "115px" }}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  {priorityOptions.map((option) => (
                                    <Select.Option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      <span style={{ color: option.color }}>
                                        {option.label}
                                      </span>
                                    </Select.Option>
                                  ))}
                                </Select>
                              </td>
                              <td className="todolistTitle">
                                <img
                                  src={bin}
                                  alt=""
                                  className="opacity-50 pointer"
                                  style={{
                                    width: "15px",
                                    height: "15px",
                                  }}
                                  onClick={() => {
                                    setTaskid(item.taskid);
                                    setDeleteModalShow(true);
                                  }}
                                />
                              </td>
                            </tr>
                          )}
                        </Draggable>
                      );
                    })}

                  {allTasks.length === 0 && (
                    <tr>
                      <td colSpan="8">
                        <div className="noDataDisplay text-center py-5">
                          {/* <Empty /> */}
                          {showLoader ? (
                            <p className="">
                              please wait while we fetching your data... &nbsp;{" "}
                              <SyncOutlined spin />
                            </p>
                          ) : (
                            <div className="noDataDisplay">
                              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              )}
            </Droppable>
          </DragDropContext>
        </table>

        <Pagination
          perPage={perPage}
          setPerPage={setPerPage}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
        />
      </div>
    </div>
  );
};

export default ToDoList;
